import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ArticleFooter.module.css';
import { Icons } from './icons';
type ArticleFooterPlatform = {
  platform: 'facebook' | 'instagram' | 'x' | 'clipboard_link';
};

export type ArticleFooterProps = {
  socials: ArticleFooterPlatform[];
};
const capitalizeWords = (str: string) => {
  return str
    .split('_')
    .map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join('');
};
export const ArticleFooter = (props: ArticleFooterProps) => {
  const { t } = useTranslation(['label']);
  const copyArticleUrlToClipboard = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const url = window.location.href;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        console.log('Link copied!', url);
      })
      .catch(err => {
        console.error('Failed to copy link: ', err);
      });
  };
  const socialIcons = useMemo(() => {
    return props.socials.map((social, index) => {
      const url = t(`CX_SOCIAL_${social.platform.toUpperCase()}_ACCOUNT`);

      const Icon = Icons[capitalizeWords(social.platform) as keyof typeof Icons];
      return (
        <div key={index}>
          <a
            data-testid={`platform-${social.platform}`}
            href={url.length !== 0 && social.platform !== 'clipboard_link' ? url : '#'}
            onClick={social.platform === 'clipboard_link' ? copyArticleUrlToClipboard : undefined}
            rel="noopener noreferrer"
            target="_blank"
          >
            <Icon />
          </a>
        </div>
      );
    });
  }, [props.socials, t]);
  return (
    <div className={styles.articleFooterWrapper} data-testid="article-footer-div">
      {socialIcons}
    </div>
  );
};
